/* STORE */

export interface IImportsCoutersState {
  importedCount: number;
  failedCount: number;
  totalCount: number;
  warningsCount: number;
  sessionId?: string;
  userId?: number;
}

export interface IImportsState extends IImportsCoutersState {
  mode: ModeTypes;
  failedLogId: string;
  serverError: string;
  coreSignalConnectionId: string | null;
  numberOfRows?: number;
}

export interface IStoreWithImports {
  imports: IImportsState;
}

export enum ModeTypes {
  'selectFile' = 'selectFile',
  'uploadStarted' = 'uploadStarted',
  'uploadFinished' = 'uploadFinished',
  'serverError' = 'serverError',
}

/* DATA */
export type IImportHubMessage = IImportProgressModel;

export interface IImportProgressModel {
  importedRowsCount: number;
  failedRowsCount: number;
  warningsCount: number;
  totalRowsCount: number;
  sessionId: string;
  userId?: number;
}

export interface IImportFinishedModel extends IImportHubMessage {
  failedLogId: string;
  sessionId: string;
  userId?: number;
}

export interface IImportFailedModel {
  errorMessage: string;
  sessionId: string;
  userId?: number;
}
